import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=08c04aa3&scoped=true&"
import script from "./setup.vue?vue&type=script&lang=js&"
export * from "./setup.vue?vue&type=script&lang=js&"
import style0 from "./setup.vue?vue&type=style&index=0&id=08c04aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c04aa3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SupportWidget: require('/codebuild/output/src3150091443/src/sviluppaimpresa-frontend/components/support/SupportWidget.vue').default})
